import { useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import formatValues from "../../../../scripts/formatValues.js";
import { getAvailableCompanies } from "../../services/getAvailableCompanies.js";
import { linkCommissionedCompany } from "../../services/linkCommissionedCompany.js";
import styles from "./css/linkCompanyModal.module.css";


export default function LinkCompanyModal({ show, agent, onClose, onLinked }) {
    const [search, setSearch] = useState("");
    const [available, setAvailable] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);

    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [selectedCompanyCost, setSelectedCompanyCost] = useState(null);
    const [commissionValueInput, setCommissionValueInput] = useState("");
    const [linkLoading, setLinkLoading] = useState(false);
    const [linkError, setLinkError] = useState(null);


    useEffect(() => {
        // RESETA O ESTADO SEMPRE QUE O MODAL ABRE (OU TROCA DE COMISSIONADO)
        setSearch("");
        setAvailable([]);
        setSelectedCompanyId(null);
        setSelectedCompanyCost(null);
        setCommissionValueInput("");
        setLinkError(null);
    }, [show, agent]);


    useEffect(() => {
        const handleSearch = async () => {
            try {
                if (!show) return;

                setSearchLoading(true);

                const data = await getAvailableCompanies({ search });
                setAvailable(data);

            } catch (err) {
                console.error("ERROR - GET AVAILABLE COMPANIES FUNCTION:", err);
                setAvailable([]);

            } finally {
                setSearchLoading(false);
            }
        };

        const timeout = setTimeout(handleSearch, 300);
        return () => clearTimeout(timeout);
    }, [show, search]);


    if (!show) return null;


    const isValueValid = commissionValueInput !== ""
        && Number.isFinite(Number(commissionValueInput))
        && Number(commissionValueInput) >= 0
        && (selectedCompanyCost === null || selectedCompanyCost === undefined || selectedCompanyCost <= 0 || Number(commissionValueInput) <= selectedCompanyCost);


    const handleSelectAvailable = (company) => {
        setSelectedCompanyId(company.id);
        setSelectedCompanyCost(company.monthlyCost);
        setCommissionValueInput("");
        setLinkError(null);
    };


    const handleLink = async () => {
        try {
            setLinkLoading(true);
            setLinkError(null);

            await linkCommissionedCompany({
                commissionedId: agent.id,
                companyId: selectedCompanyId,
                commissionValue: Number(commissionValueInput),
            });

            if (onLinked) onLinked();

        } catch (err) {
            console.error("ERROR - LINK COMMISSIONED COMPANY FUNCTION:", err);
            setLinkError(err?.response?.data?.error || "Não foi possível vincular a empresa no momento.");

        } finally {
            setLinkLoading(false);
        }
    };


    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContainer} onClick={(event) => event.stopPropagation()}>
                <header className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>Vincular empresa a {agent?.name || "comissionado"}</h2>

                    <button type="button" className={styles.closeButton} onClick={onClose}>
                        <IoMdCloseCircle size={24} color="#2f3e49" />
                    </button>
                </header>

                <div className={styles.modalBody}>
                    <input
                        className={styles.searchInput}
                        placeholder="Buscar empresa por nome ou CNPJ..."
                        value={search}
                        onChange={(event) => setSearch(event.target.value)}
                        autoFocus
                    />

                    {searchLoading ? (
                        <p className={styles.feedbackText}>Buscando empresas...</p>

                    ) : available.length === 0 ? (
                        <p className={styles.feedbackText}>Nenhuma empresa disponível encontrada para a busca.</p>

                    ) : (
                        <div className={styles.availableList}>
                            {available.map((company) => (
                                <div
                                    key={company.id}
                                    className={`${styles.availableItem} ${selectedCompanyId === company.id ? styles.selected : ''}`}
                                >
                                    <div className={styles.availableItemHeader}>
                                        <span className={styles.availableItemName}>{company.name}</span>
                                        <span className={styles.availableItemCost}>
                                            Mensalidade atual: {company.monthlyCost ? formatValues(company.monthlyCost) : 'não configurada'}
                                        </span>
                                    </div>

                                    {selectedCompanyId === company.id ? (
                                        <div className={styles.linkFormRow}>
                                            <input
                                                className={styles.valueInput}
                                                type="number"
                                                min={0}
                                                max={company.monthlyCost || undefined}
                                                step="0.01"
                                                placeholder="Valor R$"
                                                value={commissionValueInput}
                                                onChange={(event) => setCommissionValueInput(event.target.value)}
                                                autoFocus
                                            />

                                            <button
                                                type="button"
                                                className={styles.smallButton}
                                                disabled={!isValueValid || linkLoading}
                                                onClick={handleLink}
                                            >
                                                {linkLoading ? 'Vinculando...' : 'Vincular'}
                                            </button>

                                            <button
                                                type="button"
                                                className={styles.dangerButton}
                                                onClick={() => { setSelectedCompanyId(null); setSelectedCompanyCost(null); setCommissionValueInput(""); setLinkError(null); }}
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    ) : (
                                        <div className={styles.linkFormRow}>
                                            <button
                                                type="button"
                                                className={styles.smallButton}
                                                onClick={() => handleSelectAvailable(company)}
                                            >
                                                Selecionar
                                            </button>
                                        </div>
                                    )}

                                    {selectedCompanyId === company.id && linkError && (
                                        <p className={styles.inlineError}>{linkError}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
